import React, { useEffect, useRef, useState } from 'react';
import { useFormGeneratorField } from '../hooks/useFormGeneratorField';
import FormError from './FormError';


// SLICNO KAO READ-ONLY POLJE MEDJUTIM OVO KORISTIMO ZA ISTAKNUTA POLJA kao, na primer, preporucene brojcane vrednosti koje su takodje deo state-a forme.
const UniFieldDisplayValue = (props) => {
  const timeoutRef = useRef(null);
  const [clAnimation, setClAnimation] = useState("");

  const {
    warningtip,
    valueToDisplay,
  } = useFormGeneratorField(props);

  let params = {};
  if (props.params) {
    params = props.params;
  }

  let readonly = true; // uvek readonly

  let _type = 'text';
  if (params.number === true) {
    _type = 'number';
  }

  let name = 'unnamed';
  if (typeof params.name === 'string' && params.name !== '') {
    name = params.name;
  }

  let formState = {};
  if (props.formState) {
    formState = props.formState;
  }

  let formErrors = {};
  if (props.formErrors) {
    formErrors = props.formErrors;
  }

  // const handleChange = null; // nema handleChange za display polje

  // nema laznog fakeState za UniFieldDisplayValue
  /*
  let fakeState = {};
  if (props.fakeState) {
    fakeState = props.fakeState;
  }
  */


  useEffect(() => {
    // animate when value change
    setClAnimation(" uniformcompo__field--animate-value-changed");
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      //
      setClAnimation("");
    }, 334);
    return () => clearTimeout(timeoutRef.current);
  }, [formState[name]]);

  let extraClass = '';
  if (typeof params.extraclass === 'string' && params.extraclass !== '') {
    extraClass = ' ' + params.extraclass;
  }

  let cl = 'uniformcompo__field uniformcompo__field--display-value' + clAnimation + extraClass;
  if (typeof formErrors[name] === 'string' && formErrors[name] !== '') {
    cl += ' error';
  }

  let style = {};
  if (params.w > 0) {
    style = {
      width: params.w
    };
  }

  let tooltip = null;
  if (typeof params.tooltip === 'string' && params.tooltip !== '') {
    tooltip = params.tooltip;
  }

  const infotip = 'name: ' + name + ' (' + _type + ')';

  return (
    <>
      <div className={cl} style={style}>
        <label htmlFor={name}>
          {
            tooltip ? (<abbr title={tooltip}>{params.label}</abbr>) : (params.label)
          }
        </label>
        <FormError error={formErrors[name]} />
        <div className="uniformcompo__field__infotip-container"><div className="uniformcompo__field__infotip">{infotip}</div></div>
        {
          warningtip ? (
            <div className="uniformcompo__field__warningtip-container"><div className={"uniformcompo__field__warningtip" + (" frfr-js-tinytag frfr-js-tinytag--primitive-value-type--" + warningtip)}>{warningtip}</div></div>
          ) : null
        }
        <input
          type={_type}
          name={name}
          readOnly={readonly}
          value={valueToDisplay}
        />
      </div>
    </>
  );
};

export default UniFieldDisplayValue;

// value={formState[name]}